/**
 * Tabs — wrapper sobre Polaris Tabs.
 * Visual: idéntica a Polaris Tabs hoy.
 * Beneficio: los componentes no importan directamente @shopify/polaris.
 * Migración futura: cambiar solo este archivo.
 */
import { Tabs as PolarisTabs } from '@shopify/polaris';
import type { ReactNode } from 'react';

export interface TabItem {
  id: string;
  content: string;
}

interface TabsProps {
  tabs: TabItem[];
  selected: number;
  onSelect: (index: number) => void;
  children?: ReactNode;
}

export function Tabs({ tabs, selected, onSelect, children }: TabsProps) {
  return (
    <PolarisTabs tabs={tabs} selected={selected} onSelect={onSelect}>
      {children}
    </PolarisTabs>
  );
}
